import React from 'react';
import ReactDom from 'react-dom';

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {deepBind} from 'base-contentmodel';

import BaseComponent from 'base-component';
import BaseContentModel from 'base-contentmodel';

import {ProgressBarComponent} from './component';

export class ProgressBarContentModel extends BaseContentModel {

    static get _slots() {
        return {
            label: "",
            value: "",
            variable: "",
            css: "",
        };
    }

    static get _defaults() {
        return {
            label: "Input Field Label",
            value: "G:UserInputField_Sample:G",
            variable: "",
            css: "",
        };
    }

    Component = ProgressBarComponent

    @observable
    /* @slot */ label = "";

    @observable
    /* @slot */ value = "";

    @observable
    /* @slot */ variable = "";

    @observable
    /* @slot */ css = "";
}


export default ProgressBarContentModel;



// WEBPACK FOOTER //
// ./app_modules/form-control-activity/progress/contentmodel.js